"use strict";

exports.__esModule = true;
var _payment = require("./payment/payment");
Object.keys(_payment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _payment[key]) return;
  exports[key] = _payment[key];
});
var _service = require("./service/service");
Object.keys(_service).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _service[key]) return;
  exports[key] = _service[key];
});
var _serviceOptionsAndVariants = require("./serviceOptionsAndVariants/serviceOptionsAndVariants");
Object.keys(_serviceOptionsAndVariants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _serviceOptionsAndVariants[key]) return;
  exports[key] = _serviceOptionsAndVariants[key];
});
var _duration = require("./duration/duration");
Object.keys(_duration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _duration[key]) return;
  exports[key] = _duration[key];
});
var _activeFeature = require("./activeFeature/activeFeature");
Object.keys(_activeFeature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _activeFeature[key]) return;
  exports[key] = _activeFeature[key];
});
var _businessInfo = require("./businessInfo/businessInfo");
Object.keys(_businessInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _businessInfo[key]) return;
  exports[key] = _businessInfo[key];
});
var _legacyToSettingsResponse = require("./legacyToSettingsRespone/legacyToSettingsResponse");
Object.keys(_legacyToSettingsResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _legacyToSettingsResponse[key]) return;
  exports[key] = _legacyToSettingsResponse[key];
});
var _legacyToSettingsFeatures = require("./activeFeature/legacyToSettingsFeatures");
Object.keys(_legacyToSettingsFeatures).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _legacyToSettingsFeatures[key]) return;
  exports[key] = _legacyToSettingsFeatures[key];
});
var _bookingsSettings = require("./bookingsSettings/bookingsSettings");
Object.keys(_bookingsSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _bookingsSettings[key]) return;
  exports[key] = _bookingsSettings[key];
});
var _widgetName = require("./widgetName/widgetName");
Object.keys(_widgetName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widgetName[key]) return;
  exports[key] = _widgetName[key];
});
//# sourceMappingURL=index.js.map